import styled from 'styled-components';
import bgImage from './../../images/menu_bar_background.svg';

export const NavWrapper = styled.div`
  width: 100%;
  position: fixed;
  background: url(${bgImage});
  background-repeat: repeat-x;
  background-position: 2px 37px;
  z-index: 9999;
  transition: top 0.4s ease-in-out;
  top: 0;
  ${({ scroll }) => (scroll > 200 ? `top: -44px;` : `top: 0;`)}
  @media (max-width: 600px) {
    top: -44px;
  }
`;

export const Navigation = styled.nav`
  width: 1200px;
  height: 128px;
  margin: auto;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1200px) {
    width: 100%;
  }
`;

export const MobileTrigger = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: relative;
  display: none;

  div {
    width: 40px;
    height: 4px;
    background-color: #fff;
    border-radius: 5px;
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;

    ::before,
    ::after {
      content: '';
      position: absolute;
      width: 40px;
      height: 4px;
      background-color: #fff;
      border-radius: 5px;
    }
    ::before {
      top: 12px;
    }

    ::after {
      bottom: 12px;
    }
  }

  @media (max-width: 1030px) {
    display: block;
  }
`;
